<template>
  <div>
    <v-window v-model="step" class="transition">
      <v-window-item :value="1">
        <tariff-change
          :param="params"
          @change="change"
          @closeDialog="closeDialog"
        ></tariff-change>
      </v-window-item>
      <v-window-item :value="2" class="pa-md-3">
        <tariff-change-confirm
          :tarif_id="params.id"
          :service_id="params.service_id"
          @cancel="cancel"
          @closeDialog="closeDialog"
        ></tariff-change-confirm>
      </v-window-item>
    </v-window>
  </div>
</template>
<script>
import TariffChange from "../tariff/TariffChange.vue";
import TariffChangeConfirm from "../tariff/TariffChangeConfirm.vue";

export default {
  name: "TariffVWindow",
  components: {
    TariffChange,
    TariffChangeConfirm
  },
  data: () => ({
    step: 1
  }),
  props: {
    // включает в себя
    // tarif_id - id текущего тарифа
    // id - id выбранного тарифа для отправки заявки менеджеру
    // service_id - service_id хотспота
    params: {
      type: Object,
      required: true
    }
  },

  methods: {
    // следующий шаг (кнопка выбрать)
    change(params) {
      this.params.id = params.tarif_id;
      this.step++;
    },
    // отмена изменения тарифа
    cancel() {
      this.params.id = "";
      this.step--;
    },
    // закрыть окно
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>
